import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import { PhoneIcon, MailIcon, PinIcon } from "../components/icons";
import styles from "./Contact.module.css";

function Contact() {
  return (
    <>
      <SEO
        title="Contact | BOI Gardens & Car Cleaning"
        description="Get in touch to book gardening or car cleaning in Kerikeri, New Zealand."
      />

      <Navbar />

      <main className={styles.page}>
        <div className={styles.bg} aria-hidden="true" />

        <div className={styles.wrap}>
          <div className={styles.head}>
            <span className="eyebrow">Get in touch</span>
            <h1>Let's get you booked in</h1>
            <p>Call, text, or email — whatever's easiest.</p>
          </div>

          <div className={styles.card}>
            <div className={styles.name}>Michael Crichton</div>

            <a href="tel:+64276655450" className={styles.row}>
              <PhoneIcon className={styles.rowIcon} />
              <span>
                <span className={styles.rowLabel}>Phone</span>
                <span className={styles.rowValue}>+64 27 665 5450</span>
              </span>
            </a>

            <a href="mailto:michael.j.crichton@gmail.com" className={styles.row}>
              <MailIcon className={styles.rowIcon} />
              <span>
                <span className={styles.rowLabel}>Email</span>
                <span className={styles.rowValue}>
                  michael.j.crichton@gmail.com
                </span>
              </span>
            </a>

            <div className={styles.row}>
              <PinIcon className={styles.rowIcon} />
              <span>
                <span className={styles.rowLabel}>Location</span>
                <span className={styles.rowValue}>Kerikeri, New Zealand</span>
              </span>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Contact;
